import React, { useEffect, useRef } from "react";

import fpLogo from "@/assets/fp-logo-v1.png";

import { postToApp } from "./appShellBridge";

/** The message the app's web view bridge reads (`src/web/shell.ts` there). */
export const SESSION_EXPIRED_MESSAGE = { type: "fp:session-expired" } as const;

/**
 * App mode with no usable session (#9163): no session was handed over, or
 * the server rejected the one that was.
 *
 * The page cannot sign anyone in inside the Finpilot Notetaker app: the app
 * signs in natively and hands the page its session before it loads. So the
 * page tells the app, once, which signs the app out and puts its own sign-in
 * screen up; this is what shows underneath for the moment that takes.
 */
const AppShellSignInRequired: React.FC = () => {
  // Once per mount, including React's development double-mount: the ref
  // outlives the simulated unmount.
  const told = useRef(false);
  useEffect(() => {
    if (told.current) return;
    told.current = true;
    postToApp(SESSION_EXPIRED_MESSAGE);
  }, []);

  return (
    <div className="flex h-full w-full items-center justify-center bg-white p-8">
      <div className="flex max-w-sm flex-col items-center gap-4 text-center">
        <div className="flex h-12 w-12 items-center justify-center rounded-[10px] bg-[#ECEDEF]">
          <img src={fpLogo} alt="" className="h-6 w-6 object-contain" />
        </div>
        <div className="text-base font-semibold text-[#10141B]">
          Sign in from the app
        </div>
      </div>
    </div>
  );
};

export default AppShellSignInRequired;
